import React from 'react'
import { Formik } from 'formik'
import { userSecurityQuestionsValidationSchemaFormik } from 'shared/userSecurityQuestions'
import {
  SecurityQuestionsDataInput,
  UserSecurityQuestionsEnum
} from 'front-end/src/graphql/public/PublicSchemaTypes'

export type ResetPasswordViaSecurityQuestionsFormValues =
  SecurityQuestionsDataInput[]

type WithResetPasswordViaSecurityQuestionsFormikProps = {
  onSubmit: (formData: ResetPasswordViaSecurityQuestionsFormValues) => void
  questions: UserSecurityQuestionsEnum[]
}

export const WithResetPasswordViaSecurityQuestionsFormik: React.FC<WithResetPasswordViaSecurityQuestionsFormikProps> =
  ({ children, onSubmit, questions }) => {
    return (
      <Formik
        onSubmit={onSubmit}
        initialValues={questions.map((question) => ({
          question,
          answer: ''
        }))}
        enableReinitialize
        validateOnMount
        validationSchema={userSecurityQuestionsValidationSchemaFormik}
      >
        {children}
      </Formik>
    )
  }
